import React from "react";

import { FooterWrapper } from "./styles";

export function Footer() {
  return <FooterWrapper id="help-center-footer" />;
}
